import React from 'react';
import avatarColor, { initialOf } from '../lib/avatarColor';

/**
 * Profilbild, eller initialen på en färgad platta när bild saknas.
 * Färgen härleds ur namnet så att samma person alltid får samma kulör och
 * listan går att skumma.
 */
export default function Avatar({ src, name = '', size = 'md', sharing = false }) {
  const initial = initialOf(name);

  return (
    <span className={`avatar-chip avatar-chip--${size}`}>
      {src ? (
        <img className="avatar-chip__image" src={src} alt="" />
      ) : (
        <span className="avatar-chip__initial" style={{ background: avatarColor(name) }}>
          {initial}
        </span>
      )}
      {sharing && <span className="avatar-chip__dot" title="Delar sin plats" />}
    </span>
  );
}
